<template>
  <div class="bind-card-view-editpage">
    <van-form @submit="onSubmit">
      <van-field
        v-model="username"
        :disabled="countDownTime != 0"
        :rules="[{ required: true, message: '请填写姓名' }]"
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        v-model="idCardNumber"
        :disabled="countDownTime != 0"
        :rules="
          ftype === '1'
            ? [
                {
                  required: true,
                  message: '请填写证件号',
                },
              ]
            : [
                {
                  required: true,
                  message: '请填写证件号',
                },
              ]
        "
        label="证件号"
        placeholder="请输入证件号"
      />
      <p style="color: red; font-size: 14px; margin-left: 110px">
        (请输入身份证、台胞证、或其他证件)
      </p>
      <van-field
        v-model="cardNumber"
        :disabled="countDownTime != 0"
        :label="ftype === '1' ? '卡号' : '住院号'"
        :placeholder="ftype === '1' ? '请输入卡号' : '请输入住院号'"
        :rules="[{ required: true, message: '请填写卡号' }]"
      >
        <template #button>
          <van-button @click="btnClick()" size="small" type="primary">
            <div style="width: 1.3rem">
              <img
                :src="require('@assets/ic_bindcard_mark.png')"
                style="width: 100%"
                alt=""
              />
            </div>
          </van-button>
        </template>
      </van-field>
      <van-field
        v-show="ftype === '1'"
        class="bind-card-view-editpage-cardtype"
        label="卡类型"
      >
        <van-radio-group
          slot="input"
          v-model="cardType"
          :disabled="countDownTime != 0"
          direction="horizontal"
        >
          <van-radio name="0">就诊卡</van-radio>
          <van-radio name="1">社保卡</van-radio>
        </van-radio-group>
      </van-field>
      <van-field
        v-model="telphone"
        :disabled="countDownTime != 0"
        :rules="[
          {
            required: true,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请填写正确的手机号',
          },
        ]"
        label="手机号"
        type="number"
        placeholder="请输入手机号"
      />
      <van-field
        v-model="verifyCode"
        :disabled="countDownTime != 0"
        :rules="[{ required: true, message: '请填写图形验证码' }]"
        placeholder="请输入图形验证码"
      >
        <img
          slot="right-icon"
          :src="verifyCodeImage"
          @click="getVerifyCode"
          alt=""
        />
      </van-field>
      <van-field
        v-model="phoneCode"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
        placeholder="短信验证码"
      >
        <span
          slot="right-icon"
          v-if="verifyCodeImage"
          :style="countDownTime ? 'color: gray;' : 'color: blue'"
          :disabled="countDownTime > 0"
          @click="sendCode"
          class="user-setting-phone-send-verifycode"
        >
          {{ countDownTime ? `${countDownTime}s后重新发送` : "发送验证码" }}
        </span>
      </van-field>
      <ph-button
        class="bind-card-view-editpage-commit-button"
        title="立即添加"
        native-type="submit"
      />
      <div class="bind-card-view-editpage-tips">
        温馨提示：
        <div>
          1、输入的手机号必须与当前添加的就诊卡在院内建档时预留手机号一致
        </div>
        <div>2、如预留手机号已无法使用，请前往收费窗口更改后进行添加</div>
        <div v-if="ftype === '2'" style="color: red">
          3、新生儿科患者，身份证请填写住院号
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: {
    ftype: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      username: "",
      idCardNumber: "",
      cardNumber: "",
      cardType: "0",
      telphone: "",
      verifyCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      phoneCode: "",
      countDownTime: 0,
      timer: null,
    };
  },
  mounted() {
    this.getVerifyCode();
  },
  methods: {
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then((res) => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    onSubmit() {
      if (!this.cardNumber) {
        this.$toast("请输入卡号");
        return;
      }
      if (!this.username) {
        this.$toast("请输入姓名");
        return;
      }
      if (!this.idCardNumber) {
        this.$toast("请输入证件号");
        return;
      }
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.phoneCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      this.submitCardBound({
        name: this.username.trim(),
        idCard: this.idCardNumber.trim(),
        cardType: this.ftype === "1" ? this.cardType : "2",
        cardNo: this.cardNumber.trim(),
        phone: this.telphone,
        smsCode: this.phoneCode,
      });
    },
    submitCardBound(params) {
      this.$http
        .post(this.$api.USER_BIND_CARD, {
          functionType: this.ftype,
          ...params,
        })
        .then(() => {
          this.$router.replace({
            name: "change-card",
            query: {
              ftype: this.ftype,
            },
          });
        });
    },
    btnClick() {
      if (this.ftype === "2") {
        ImagePreview([
          "http://app.fjlyrmyy.com/palmhospital/tips/InpatientNo.png",
        ]);
      } else {
        if (this.cardType === "0") {
          ImagePreview([
            "http://app.fjlyrmyy.com/palmhospital/tips/HealthCard.png",
          ]);
        } else {
          ImagePreview([
            "http://app.fjlyrmyy.com/palmhospital/tips/Sscard.png",
          ]);
        }
      }
    },
    sendCode() {
      if (!this.cardNumber) {
        this.$toast("请输入卡号");
        return;
      }
      if (!this.username) {
        this.$toast("请输入姓名");
        return;
      }
      if (!this.idCardNumber) {
        this.$toast("请输入证件号");
        return;
      }
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      this.confirmSendCode();
      // if (this.ftype == "2") {
      // } else {
      //   this.$dialog.confirm({
      //     message: "请确认您添加的就诊卡与所选择的卡类型是否一致"
      //   }).then(() => {
      //     this.confirmSendCode()
      //   })
      // }
    },
    confirmSendCode() {
      this.$http
        .post(this.$api.CARDS_SEND_CODE, {
          functionType: this.ftype,
          cardType: this.ftype === "1" ? this.cardType : "2",
          cardNo: this.cardNumber.trim(),
          name: this.username,
          idCard: this.idCardNumber,
          picId: this.verifyCodeId,
          picCode: this.verifyCode,
          phone: this.telphone,
        })
        .then(() => {
          this.startCountDown();
        });
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less">
.bind-card-view-editpage {
  &-cardtype .van-field__control > div {
    justify-content: space-around;
    width: 100%;
  }

  &-commit-button {
    margin-top: 1rem;
  }
  &-tips {
    margin: 1rem 0.4rem;
    color: red;
    font-size: 0.8rem;
    div {
      color: gray;
    }
  }
}

.bind-card-view .van-field__body {
  font-size: 0.94rem;
}

.bind-card-view .van-button__content {
  font-size: 0.94rem;
}
.bind-card-view .van-field__label {
  font-size: 0.94rem;
}
</style>
